import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent6"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code6-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code6-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Other Badges", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab6",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview6-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview6-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview6-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code6-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code6-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code6-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview6-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview6-tab",
          tabindex: "0"
        }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary fw-medium text-white"
          }, [
            _createTextVNode(" Notifications "),
            _createElementVNode("span", { class: "badge text-bg-danger text-white" }, "4")
          ]),
          _createElementVNode("div", { class: "mb-4" }),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary position-relative fw-medium text-white"
          }, [
            _createTextVNode(" Inbox "),
            _createElementVNode("span", { class: "position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" }, [
              _createTextVNode(" 99+ "),
              _createElementVNode("span", { class: "visually-hidden" }, "unread messages")
            ])
          ]),
          _createElementVNode("div", { class: "mb-4" }),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary position-relative fw-medium text-white"
          }, [
            _createTextVNode(" Profile "),
            _createElementVNode("span", { class: "position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle" }, [
              _createElementVNode("span", { class: "visually-hidden" }, "New alerts")
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "codeCopy"
            }, "\n<button type=\"button\" class=\"btn btn-primary fw-medium text-white\">\nNotifications <span class=\"badge text-bg-danger text-white\">4</span>\n</button>\n\n<button type=\"button\" class=\"btn btn-primary position-relative fw-medium text-white\">\nInbox\n<span class=\"position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger\">\n99+\n<span class=\"visually-hidden\">unread messages</span>\n</span>\n</button>\n\n<button type=\"button\" class=\"btn btn-primary position-relative fw-medium text-white\">\nProfile\n<span class=\"position-absolute top-0 start-100 translate-middle p-2 bg-danger border border-light rounded-circle\">\n<span class=\"visually-hidden\">New alerts</span>\n</span>\n</button>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}